export interface HeatmapIntervalSegment {
  duration: {
    opacity: number;
    value: number;
  };
  interactions: {
    opacity: number;
    value: number;
  };
  localSegment: number;
}

export interface HeatMapMember {
  userId: string;
  segments: HeatmapIntervalSegment[];
}

export type HeatMap = HeatMapMember[];

export interface HeatMapAnalyticsActivity {
  userid: string;
  interval15: string;
  totalDuration: string;
  count: string;
}

type HeatMapDistinctDaysMember = {
  userId: string;
  dayCount: number;
};

export type HeatMapDistinctDays = HeatMapDistinctDaysMember[];
